import React from "react";
import { Label } from "@/components/ui/label";
import { useSettings } from "@/context/SettingsContext";
import { Check } from "lucide-react";

export function PaymentTypesField({ value = [], onChange }) {
  const { settings } = useSettings();
  const options = settings?.payment_type_options || [];
  const selected = value || [];
  const toggle = (opt) => {
    onChange(selected.includes(opt) ? selected.filter((v) => v !== opt) : [...selected, opt]);
  };
  return (
    <div className="space-y-2">
      <Label>Payment types accepted</Label>
      <div className="flex flex-wrap gap-2" data-testid="payment-types-field">
        {options.map((opt) => {
          const on = selected.includes(opt);
          return (
            <button
              type="button"
              key={opt}
              onClick={() => toggle(opt)}
              data-testid={`payment-type-${opt}`}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm transition-colors ${on ? "bg-[#1A365D] border-[#1A365D] text-white" : "bg-white border-[#E8E6DF] text-[#4A534E] hover:border-[#1A365D]"}`}
            >
              {on && <Check className="h-3.5 w-3.5" />} {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
